// ** Reducers Imports
import publicStore from '../routes/app/public/store';
import policyWalletStore from '../routes/app/auth/policy_wallet/store';
import commonStore from '../common/store';
import dashboardStore from '../routes/app/auth/dashboard/store';
import claimStore from '../routes/app/auth/claim/store';
import MyProfileStore from '../routes/app/auth/my_profile/store';
import appointmentsStore from '../routes/app/auth/appointments/store';
import enquiryAddStore from '../routes/app/auth/enquiry/store';
import reviewsStore from '../routes/app/auth/reviews/store';
import NotificationStore from '../routes/app/auth/notifications/store';


const rootReducer = {
    publicStore,
    policyWalletStore,
    commonStore,
    dashboardStore,
    claimStore,
    MyProfileStore,
    appointmentsStore,
    enquiryAddStore,
    reviewsStore,
    NotificationStore
}

export default rootReducer
